let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("bF0Yj")).then(() => parcelRequire('3wpz4'));